import { ComboInput } from "../combo-input";

interface Props {
  value: string[];
  onChange: (newValue: string[]) => void;
}

export function JobFilter({ value, onChange }: Props) {
  return (
    <ComboInput
      placeholder="Job title (press enter to add)"
      value={value}
      onChange={onChange}
      isActive={value.length > 0}
      inputContainerProps={{ minW: 48 }}
      inputProps={{ w: 48 }}
    />
  );
}
